import { useSelector } from "react-redux";
import { useProposalTypeData } from "../proposal/use-proposal-type-data";
import { selectGCLIRates6670, selectGCLIRates7175, selectGCLIRates7680, selectRatesOf1865 } from "../../features/actuarial/rates-slice";
import { selectAnnualPremiumAmount, selectEvidenceNotes } from "../../features/actuarial/annual-premium-eoi.slice";
import { validate1865, validate66to80Group } from "../../utils/validate-rates-amount-1880.utils";
import { useToastify } from "../../library/toastify/toast-provider";
import { validate1865MonthConsistency, validate6680AgeConsistency, validate6680MonthConsistency, validateGYRTGPARates } from "./user-rates-age-braket-validation";

export function useRatesValidation() {

    const { showToastNotify } = useToastify();
    const { hasNo6680Rates, isRatesIsAgeType, borrowerAge6670, borrowerAge7175, borrowerAge7680 } = useProposalTypeData();
    const rate1865 = useSelector(selectRatesOf1865);
    const gcliRates6670 = useSelector(selectGCLIRates6670);
    const gcliRates7175 = useSelector(selectGCLIRates7175);
    const gcliRates7680 = useSelector(selectGCLIRates7680);

    const annualPremiumAmount = useSelector(selectAnnualPremiumAmount);
    const evidenceNotes = useSelector(selectEvidenceNotes);
    const validateRates = (): boolean => {
        // 18 to 65 validation
        if (!isRatesIsAgeType) {
            const monthError = validate1865MonthConsistency(rate1865 ?? []);
            if (monthError) {
                showToastNotify(monthError, 'warning');
                return false;
            }
        } else {
            // Replace this with the selector containing your GYRT/GPA rates.
            const gyrtGpaError = validateGYRTGPARates(rate1865 ?? []);
            if (gyrtGpaError) {
                showToastNotify(gyrtGpaError, 'warning');
                return false;
            }
        }

        const errors = validate1865(rate1865);

        if (errors.length > 0) {
            const firstError = errors[0];
            showToastNotify(`${firstError.age} of "${firstError.name}" has empty rate`, "warning");
            return false;
        }

        // 66 to 80 validation
        if (!hasNo6680Rates) {
            if (!isRatesIsAgeType) {
                // borrowerAge6670, borrowerAge7175, borrowerAge7680
                const monthError =
                    (borrowerAge6670 && validate6680MonthConsistency(gcliRates6670 ?? [])) ||
                    (borrowerAge7175 && validate6680MonthConsistency(gcliRates7175 ?? [])) ||
                    (borrowerAge7680 && validate6680MonthConsistency(gcliRates7680 ?? []));

                if (monthError) {
                    showToastNotify(monthError, 'warning');
                    return false;
                }
            } else {
                // borrowerAge6670, borrowerAge7175, borrowerAge7680
                const ageError = 
                    (borrowerAge6670 && validate6680AgeConsistency(gcliRates6670 ?? [])) ||
                    (borrowerAge7175 && validate6680AgeConsistency(gcliRates7175 ?? [])) ||
                    (borrowerAge7680 && validate6680AgeConsistency(gcliRates7680 ?? []));


                if (ageError) {
                    showToastNotify(ageError, 'warning');
                    return false;
                }
            }
            const groups = [
                { data: gcliRates6670 ?? [], label: "66-70" },
                { data: gcliRates7175 ?? [], label: "71-75" },
                { data: gcliRates7680 ?? [], label: "76-80" },
            ];

            for (const group of groups) {
                if (!validate66to80Group(group.data, group.label, showToastNotify)) {
                    return false;
                }
            }
        }

        return true;
    };

    const validateEoI = () => {
        if (!evidenceNotes) {
            showToastNotify("Evidence notes must be provided", 'warning');
            return false;
        }
        return true;
    }

    const validateTotalAnnualPremium = () => {
        if (!annualPremiumAmount) {
            showToastNotify("Total Annual Premium must have a valid amount greater than 0", 'warning');
            return false;
        }
        return true;
    }

    return { 
        validateRates, 
        validateEoI, 
        validateTotalAnnualPremium 
    };
}